
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Phone } from 'lucide-react';

interface PhoneFieldProps {
  phone: string;
  setPhone: (phone: string) => void;
  error?: string;
}

const PhoneField = ({ phone, setPhone, error }: PhoneFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="phone">
        Phone Number <span className="text-red-500">*</span>
      </Label>
      <div className="relative">
        <Phone className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
        <Input
          id="phone"
          type="tel"
          placeholder="10-digit number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className={`pl-10 ${error ? 'border-red-500' : ''}`}
          required
        />
      </div>
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default PhoneField;
